import { all, call, take, cancelled, cancel, fork } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'

const observer = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(querySnapshot => {
      const objects = {}

      if (querySnapshot.docs) {
        querySnapshot.forEach(doc => {
          objects[doc.id] = { ...doc.data(), id: doc.id }
        })

        emit(objects)
      } else {
        const data = querySnapshot.data()

        emit(data ? { ...data, id: querySnapshot.id } : {})
      }
    }, err => {
      emit(new Error(err))
    })

    return () => subscriber
  })

  return listener
}

function* subscribe(params) {
  const channel = yield call(observer, params.ref)

  try {
    while (true) {
      const data = yield take(channel)

      let payload = yield call(params.onChange, data)

      if (payload) {
        if (!Array.isArray(payload)) payload = [payload]

        yield all(payload)
      }
    }
  } catch (err) {
    let payload = yield call(params.onError, err)

    if (payload) {
      if (!Array.isArray(payload)) payload = [payload]

      yield all(payload)
    }
  } finally {
    if (yield cancelled()) {
      channel.close()
    }
  }
}

export function* sync(payload) {
  const task = yield fork(subscribe, payload)

  yield take(payload.unSync)
  yield cancel(task)
}


// WEBPACK FOOTER //
// ./src/sagas/concern/helpers.js